import React from "react";
import { Outlet, Navigate } from 'react-router-dom'
import AuthService from "./AuthService";



const ProtectedRoute = (props) => {

  console.log("ProtectedRoute", props,props.permission)                         


  const checkAuthendication = () => {
    return AuthService.checkPermission(props.permission);
  }


  if (AuthService.isLoggedIn()) {
    let permissionGranted = checkAuthendication();
    console.log("permissionGranted", permissionGranted)                         

    if (permissionGranted) {
      return <Outlet {...props} />;
    } else if (!permissionGranted) {
      return <Navigate replace to='/errorpermission' />;
    } else {
      return <Navigate replace to='/error-401' />;
    }

  } else {
    return <Navigate replace to='/errorpermission' />;
  }
}

export default ProtectedRoute;

